const CalendarEvent = {
  btnLoadMore: null,

  init: () => {
    // check if page is event archive...
    const isCalendarEventArchive = document.querySelector(
      "body.post-type-archive-event"
    );
    if (!isCalendarEventArchive) return;

    // find load more button for CalendarEvent archive
    CalendarEvent.btnLoadMore = document.getElementById(
      "calendar-event-load-more"
    );

    if (CalendarEvent.btnLoadMore) {
      // CalendarEvent load more button: activate!!!
      CalendarEvent.btnLoadMore.addEventListener("click", function () {
        CalendarEvent.btnLoadMore.classList.add("animate--pulsate");
        CalendarEvent.btnLoadMore.innerText = "Laddar...";
        CalendarEvent.handleSubmit();
      });
    }
  },

  handleSubmit: () => {
    // digi ajax url
    let url = digiteketData.ajaxUrl;

    // get next page
    digiteketData.currentPage++;

    // setup fetch data
    const data = {
      action: "digi_events_load_more",
      nonce: digiteketData.nonce,
      paged: digiteketData.currentPage,
    };

    // encode query data to be sent
    const query = CalendarEvent.encodeData(data);

    // append query data to ajax url
    if (query.length) {
      url += "?" + query;
    }

    // config fetch options
    const options = {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    };

    // load more event posts
    fetch(url, options)
      .then((res) => {
        // promise returned
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.json();
      })
      .then((res) => {
        // success
        const data = res.data;

        // get pre-rendered post items
        const items = data.items;

        console.log(items);

        // get posts wrapper
        const resultsWrapper = document.getElementById("results");

        if (items && items.length != -1) {
          if (resultsWrapper) {
            items.forEach((item, index) => {
              // render each post item to the DOM
              resultsWrapper.insertAdjacentHTML("beforeend", item);

              if (index === 0) {
                // set focus to first new post item
                resultsWrapper.lastChild.focus();
              }
            });
          }
        }

        // update maxPage
        digiteketData.maxPage = data.maxNumPages;

        CalendarEvent.btnLoadMore.classList.remove("animate--pulsate");

        // update btn status
        if (digiteketData.currentPage >= digiteketData.maxPage) {
          CalendarEvent.btnLoadMore.setAttribute("disabled", "");
          CalendarEvent.btnLoadMore.remove();
        } else {
          CalendarEvent.btnLoadMore.removeAttribute("disabled");
          CalendarEvent.btnLoadMore.innerText = "Ladda fler event";
        }
      })
      .catch((err) => {
        // error
        console.log(err);

        // update btn status
        CalendarEvent.btnLoadMore.classList.remove("animate--pulsate");
        CalendarEvent.btnLoadMore.removeAttribute("disabled");
        CalendarEvent.btnLoadMore.innerText = "Ladda fler event";
      });
  },

  encodeData: (data) => {
    const payload = [];

    for (const [key, value] of Object.entries(data)) {
      payload.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }

    return payload.join("&");
  },
};

export default CalendarEvent;
